import { render } from "./LimitedPromotionPackage.vue?vue&type=template&id=3f8d9a94&scoped=true"
import script from "./LimitedPromotionPackage.vue?vue&type=script&lang=js"
export * from "./LimitedPromotionPackage.vue?vue&type=script&lang=js"

import "./LimitedPromotionPackage.vue?vue&type=style&index=0&id=3f8d9a94&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8d9a94"]])

export default __exports__